import { createAction } from '@reduxjs/toolkit';

export const i18nLoadRequest = createAction<{
	langId: number;
	langCode: string;
}>('i18n/load/request');
export const i18nLoadSuccess = createAction<{
	langCode: string;
	bundle: Record<string, string>;
}>('i18n/load/success');
export const i18nLoadFailure = createAction<string>('i18n/load/failure');

export const i18nChangeLanguage = createAction<{ langCode: string }>('i18n/changeLanguage');
